import React, {Component} from 'react';
import {Row, Col, Alert, Timeline, Card} from 'antd';
import ReactJson from 'react-json-view';

import {Order} from '../../../../../../interfaces';

const {Item} = Timeline;

interface Properties {
  orderData: Order;
}

class Detail extends Component<Properties> {
  render() {
    const {orderData:{order,errors}} = this.props;    
    return (
      <>
        <Row>
          <Col span={12}>
            <Card title="Order data" bordered={false}>
              <ReactJson name={false} src={order} collapsed={1} />
            </Card>
          </Col>
          <Col span={12}>
            <Card title="error data" bordered={false}>
              <ReactJson name={false} src={errors} collapsed={1} />
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/ListOrders/components/ListOrders/components/Detail/Detail.tsx